import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'et-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FooterComponent {}
